import pkg from '../package.json';

export const ENV = (process.env.REACT_APP_ENV || 'production').trim();
export const PRIVACY_POLICY_URL = (process.env.REACT_APP_PRIVACY_POLICY_URL || 'https://www.thesiliconpartners.com/privacy-policy/').trim();
export const TERMS_OF_USE_URL = (process.env.REACT_APP_TERMS_OF_USE_URL || 'https://www.thesiliconpartners.com/terms-of-use/').trim();
export const VERSION = pkg.version;
export const API_ENDPOINT = (process.env.REACT_APP_API_ENDPOINT || '').trim();
export const API_SIGNATURE_HEADER = (process.env.REACT_APP_API_SIGNATURE_HEADER || '').trim();
export const CDN_ENDPOINT = (process.env.REACT_APP_CDN_ENDPOINT || '').trim();
export const LATAMLOCATIONS = (process.env.REACT_APP_ZOHO_LOCATIONS_LATAM || 'Brazil,BRAZIL,BRASIL,LAC,Delivery Center,Mexico,Argentina,Colombia,PERU,Peru,COLOMBIA')
  .trim()
  .split(',');
export const USLOCATIONS = (process.env.REACT_APP_ZOHO_LOCATIONS_US || 'U.S.A').trim().split(',');
export const INDIALOCATIONS = (process.env.REACT_APP_ZOHO_LOCATIONS_INDIA || 'Hyderabad,Noida,Pune,Sibros-Pune').trim().split(',');
export const REGIONS = (process.env.REACT_APP_ZOHO_REGIONS || 'Latam,India,U.S.A').trim().split(',');
export const CURRENCIES = (process.env.REACT_APP_ZOHO_CURRENCIES || 'BRL,COP,INR').trim().split(',');
export const ZOHO_MANAGE_MISSING_HOURS_ID = Number(process.env.REACT_APP_ZOHO_MANAGE_MISSING_HOURS_ID) || 2;
export const ZOHO_LAC_EMAIL_REPORT_DEFAULTEMAILS = process.env.REACT_APP_ZOHO_LAC_EMAIL_REPORT_DEFAULTEMAILS || '';
export const ZOHO_LAC_EMAIL_MONTHLYAPI = process.env.REACT_APP_ZOHO_LAC_EMAIL_MONTHLYAPI || '';
export const ZOHO_LAC_EMAIL_WEEKLYAPI = process.env.REACT_APP_ZOHO_LAC_EMAIL_WEEKLYAPI || '';

if (!API_ENDPOINT) throw new Error('Please provide an API_ENDPOINT');

export const SENTRY_KEY = (process.env.REACT_APP_SENTRY_KEY || '').trim();

export const TOAST_DEFAULT_TIMEOUT = 3000;
export const TOAST_ERROR_TIMEOUT = 7000;

export const IS_DEVELOPMENT = ENV === 'development';

export function isLatamLocation(location: string): boolean {
  location = location?.replace('TSP ', '');
  return LATAMLOCATIONS.includes(location);
}